export default __webpack_public_path__ + "static/media/lock.e8723f5c.svg";